import type { AxiosInstance } from "axios";
import type { ZendeskViewReference } from "./ZendeskSourceSettings.types";

export class ZendeskSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  /**
   * Active Zendesk views the connection's signed-in user can see, for the View mode picker.
   *
   * @param boardId The board that owns the connection.
   * @param connectionId The Zendesk connection.
   * @returns The views, each with its id and title.
   */
  async getViews(boardId: string, connectionId: string): Promise<ZendeskViewReference[]> {
    const response = await this.client.get<ZendeskViewReference[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/zendesk/views`,
    );
    return response.data;
  }
}
